import { FC, ReactNode } from "react";
import { Flex, Title, Button, TitleOrder } from "@mantine/core";
import { Link } from "react-router-dom";
import { IconChevronRight } from "@tabler/icons-react";

interface WidgetHeaderProps {
  icon?: ReactNode;
  title: string;
  order?: TitleOrder;
  linkText?: string;
  linkTo?: string;
}

export const WidgetHeader: FC<WidgetHeaderProps> = ({
  icon,
  title,
  order = 4,
  linkText,
  linkTo,
}) => {
  return (
    <Flex justify="space-between" align="center" mb="sm">
      <Flex align="center" gap="xs">
        {icon}
        <Title order={order}>{title}</Title>
      </Flex>
      {linkText && linkTo && (
        <Button
          component={Link}
          to={linkTo}
          variant="subtle"
          size="xs"
          rightSection={<IconChevronRight size={14} />}
        >
          {linkText}
        </Button>
      )}
    </Flex>
  );
};
